<script setup lang="ts">
import Dropdown from "@/components/Dropdown/Dropdown.vue";
import { Placement } from "@floating-ui/vue";

const props = defineProps<{
  id?: string;
  icon?: string;
  icons?: string[];
  active?: boolean;
  showLabel?: boolean;
  label: string;
  showBusy?: boolean;
  htmlOnly?: boolean;
  disabled?: boolean;
  outsideAutoClose?: boolean;
  placement?:Placement;
  allowedPlacements?: Placement[] | null;
  disableContentAutoClose?: boolean;
  forcedContentWidth?: string;
  disableCaret?: boolean;
}>();

const fs = useFullScreenStore();

const iconClasses = computed(() => {
  let classes = props.showBusy ? "fa-spin fa-spinner-third" : props.icon;

  if (!props.icon && !props.showBusy) {
    return "";
  }

  if (!props.icon?.includes("fa-kit")) {
    classes += " fa-light";
  }
  return classes;
});
defineEmits<{
  (e: "open"): void;
  (e: "close"): void;
}>();

const dropdown = ref<InstanceType<typeof Dropdown>>();

defineExpose({
  dropdown,
});
</script>

<template>
  <Dropdown
    ref="dropdown"
    class="toolbar-button-dropdown inline"
    :disabled="disabled || showBusy"
    :title="label"
    :disable-content-dropdown-toggle="disableContentAutoClose"
    :class="{ active: active }"
    :forced-content-width="forcedContentWidth"
    :placement="placement"
    :allowed-placements="allowedPlacements"
    :disable-teleport="fs.fullScreenEnabled"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <template #btn-label>
      <FAIcon
        v-if="iconClasses"
        :class="iconClasses"
        class="fa-fw btn-icon"
      />

      <template v-else>
        <FAIcon
          v-for="i of icons"
          :key="i"
          :class="`fa-light ${i}`"
        />
      </template>

      <span
        v-if="showLabel"
        class="btn-label"
        >{{ label }}</span
      >

      <slot name="label" />
      <FAIcon
        v-if="!disableCaret"
        class="fa-solid fa-caret-down caret-icon"
      />
    </template>
    <slot />
  </Dropdown>
</template>

<style scoped lang="postcss">
:deep {
  .btn {
    @apply min-h-fit flex-nowrap gap-1 whitespace-nowrap rounded border-none bg-transparent px-2 py-3 text-gray-500 shadow-none;
    font-size: 1.25em;
    font-weight: 400;
    text-transform: unset;
  }
}
.caret-icon {
  font-size: 0.55em;
  @apply text-primary;
}
.btn-label {
  @apply max-md:hidden;
}
</style>
